import loadableWithRetry from '../common/loadableWithRetry'

const Reviews = loadableWithRetry(() => import('./Reviews'))

export default Reviews;

